<template>
  <div id="StudyJLGS" class="study">
    <div class="container-fluid head" style="background-color: #46478A">
      <Header />
      
      <h1>Website & Brand Design for JLGS INGENIEROS EIRL</h1>
    </div>

    <div class="container">

      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/JLGS/logo.png" width="90%" />
        </div>
        <div class="col-12 col-md-6">
          <h2>The Project</h2>
          <p>
            JLGS INGENIEROS is a private Peruvian engineering consulting company. they develop studies, designs of engineering projects.<br/>
          </p>
          <h2 class="mt-5">The Plan</h2>
          <p>
            JLGS INGENIEROS has become a distinguished business in Lima and requested an update to their outdated logo and website.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>My Role</h2>
          <p>
            <ul>
              <li>Logo Design & Company Branding</li>
              <li>Wireframes & Web Design</li>
            </ul>
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <h2>The Problem</h2>
          <p>
            JLGS Ingenieros is growing and have seen the importance of a reputable and professional web presence. The limited information about their services and the difficulty to find any information wasn't that professional and it was not suitable for an engineering company.
          </p>
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/JLGS/oldlogo.png" width="100%"/>
          <p class="imglabel">The previous logo lacked a sense of legitimacy. The new design would show more profesionalism and confidence.</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-12">
          <h2>Wireframing</h2>
          <img src="/images/JLGS/wireframe.png" width="100%" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>Crafting a brand identity</h2>
          <p>
            I combined a variety of shades of wedgewood, purple, and gray to represent JLGS Ingenieros's brand.<br/><br/>
            For typography, I utilized a minimalist sans serif font, Mulish Bold for headers; Mulish semibold for body text. 
          </p>
          <br />
          <br />
          <img src="/images/JLGS/typography.png" width="100%" />
          <img src="/images/JLGS/colorguide.png" width="100%" class="mt-5" />
          <img src="/images/JLGS/logo_explained.png" width="100%" class="mt-5" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>The Solution</h2>
          <img src="/images/JLGS/webpreview.png" width="100%" />
          <img src="/images/JLGS/macpreview.png" width="100%" class="mt-5" />
          <img src="/images/JLGS/pdfsample.png" width="100%" class="mt-5" />
        </div>
      </div>

    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "StudyJLGS",
  components: { Header, Footer },
  data: function () {
    return {
      slides: [],
    };
  },
  methods: {},
  mounted: function () {},
};
</script>

<style lang="scss">
#StudyJLGS {
  h2 {
    color: #46478a;
  }
}
</style>